// extracted by mini-css-extract-plugin
module.exports = {"slot":"appointments__ClinicianVisibilitySlot__slot","slotClickable":"appointments__ClinicianVisibilitySlot__slotClickable"};